<template>
  <a-card :bordered="false">
    <component @onEdit="handleEdit" @onGoBack="handleGoBack" :record="record" :is="currentComponet"></component>
  </a-card>
</template>

<script>
import List from '@/views/a-business-card/table/List'
import Edit from '@/views/a-business-card/table/Edit'

export default {
  name: 'BusinessCard',
  components: {
    List,
    Edit
  },
  data () {
    return {
      currentComponet: 'List',
      record: ''
    }
  },
  mounted () {
    // 如果有 id 参数，则显示编辑页面
    const id = this.$route.params.id
    if (id) {
      this.currentComponet = 'Edit'
    }
  },
  methods: {
    handleEdit (record) {
      this.record = record || ''
      this.currentComponet = 'Edit'
      // 跳转到编辑页面
      this.$router.push({ path: '/business_card/list/' + record.id })
    },
    handleGoBack () {
      this.record = ''
      this.currentComponet = 'List'
      this.$router.push({ path: '/business_card/list' })
    }
  },
  watch: {
    '$route.params.id' (newVal) {
      if (newVal) {
        this.currentComponet = 'Edit'
      } else {
        this.currentComponet = 'List'
      }
    }
  }
}
</script>
